import React, { useState, useEffect, createContext, useContext } from 'react';
import { useActiveListContext, useAllInOneContext } from '..';
import { isKeyList } from '../../helpers';
import { KEY_LISTS, DATE_FORMAT, DEFAULT_LIST, INITIAL } from '../../constants';
import moment from 'moment';

const TaskContext = createContext();

export const TaskProvider = ({ children }) => {
  const { lists, allTasks } = useAllInOneContext();
  const { activeList, setActiveList } = useActiveListContext();
  const [tasks, setTasks] = useState([]);
  const [filterTaskCounts, setFilterTaskCounts] = useState([0,0,0,0]);

  useEffect(() => {
    if (allTasks && allTasks.length > 0 && activeList == INITIAL)
      setActiveList(DEFAULT_LIST);
  }, [allTasks]);

  useEffect(() => {
    if (activeList && activeList != '' && activeList != INITIAL) {
      let fetchedTasks = [];

      if (allTasks) {
        fetchedTasks = [...allTasks];

        const realListTarget = activeList && !isKeyList(activeList);
        const Today = fetchedTasks.filter(
            (item) => item.date == moment().format(DATE_FORMAT)
          ),
          Planned = fetchedTasks.filter((item) => item.date != ''),
          Important = fetchedTasks.filter((item) => item.important == true);

        setFilterTaskCounts([Today.length, Planned.length, Important.length, fetchedTasks.length]);
        
        fetchedTasks = realListTarget
          ? fetchedTasks.filter((item) => item.listID == activeList)
          : activeList === KEY_LISTS[0]
          ? Today
          : activeList === KEY_LISTS[2]
          ? Important
          : activeList === KEY_LISTS[1]
          ? Planned
          : fetchedTasks;

        if (fetchedTasks.length > 0) {
          fetchedTasks =
            activeList === KEY_LISTS[1]
              ? fetchedTasks.sort((a, b) => new Date(a) - new Date(b))
              : fetchedTasks.sort((a, b) => a.order - b.order);

          if (!realListTarget)
            fetchedTasks = fetchedTasks.sort(
              (a, b) =>
                lists.findIndex((list) => list.docID == a.listID) -
                lists.findIndex((list) => list.docID == b.listID)
            );
        }
      }

      setTasks(fetchedTasks);
    }
  }, [activeList]);

  return (
    <TaskContext.Provider value={{ tasks, setTasks, filterTaskCounts }}>
      {children}
    </TaskContext.Provider>
  );
};

export const useTaskContext = () => useContext(TaskContext);
